export default "__VITE_ASSET__Dx8OfhgY__"